import React, { ReactElement } from "react"
import clsx from "clsx"
import { match } from "ts-pattern"
import styles from "./StepRecap.module.scss"

export type StepRecapState = "active" | "active-no-value" | "disabled"

type Props = {
    label: string
    value: string | ReactElement | undefined
    state: StepRecapState
    testId: string
}

const StepRecap: React.FC<Props> = ({ label, value, state, testId }) => {
    const className = match(state)
        .with("active", () => styles.active)
        .with("active-no-value", () => styles.activeNoValue)
        .with("disabled", () => styles.disabled)
        .exhaustive()

    return (
        <>
            <dt className={clsx(styles.label, className)}>{label}</dt>
            <dd className={styles.value} aria-hidden={state != "active"} data-test-id={testId}>
                {value}
            </dd>
        </>
    )
}

export default StepRecap
